/// <amd-module name="VSS/Reflux/Store" />
export interface IEventHandler extends Function {}

export class Store {
    private changedEvent: string;
    private handlers: { [eventName: string]: IEventHandler[] };

    constructor(changedEvent: string) {
        this.changedEvent = changedEvent;
        this.handlers = {};
    }

    public addChangedListener(handler: IEventHandler) {
        this.addListener(this.changedEvent, handler);
    }

    public removeChangedListener(handler: IEventHandler) {
        this.removeListener(this.changedEvent, handler);
    }

    public addListener(eventName: string, handler: IEventHandler): void {
        if (!this.handlers[eventName]) {
            this.handlers[eventName] = [];
        }
        this.handlers[eventName].push(handler);
    }

    public removeListener(eventName: string, handler: IEventHandler): void {
        if (this.handlers[eventName]) {
            for (let handlerIndex = this.handlers[eventName].length - 1; handlerIndex >= 0; handlerIndex--) {
                if (this.handlers[eventName][handlerIndex] === handler) {
                    this.handlers[eventName].splice(handlerIndex, 1);
                }
            }
        }
    }

    protected emitChanged(): void {
        this.emit(this.changedEvent, this);
    }

    protected emit(eventName: string, sender: {}): void {
        if (this.handlers[eventName]) {
            for (const handler of this.handlers[eventName]) {
                handler(sender);
            }
        }
    }
}
